"use strict";

/**
 * @generated SignedSource<<655bcccfd899e5d3f7195029292f6263>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = function () {
  var v0 = {
      "alias": null,
      "args": [{
        "kind": "Literal",
        "name": "portal",
        "value": "FLEET_PORTAL"
      }],
      "kind": "ScalarField",
      "name": "canAccessPortal",
      "storageKey": "canAccessPortal(portal:\"FLEET_PORTAL\")"
    },
    v1 = [{
      "kind": "Literal",
      "name": "first",
      "value": 25
    }],
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dbId",
      "storageKey": null
    },
    v3 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    v4 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "AppFmoHomeViewerWhoAmIQuery",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [{
          "args": null,
          "kind": "FragmentSpread",
          "name": "Landing_FmoHomeViewer"
        }, v0 /*: any*/, {
          "alias": null,
          "args": v1 /*: any*/,
          "concreteType": "FleetCompanyConnection",
          "kind": "LinkedField",
          "name": "fleetCompaniesAsManager",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "FleetCompanyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "FleetCompany",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [v2 /*: any*/, v3 /*: any*/],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": "fleetCompaniesAsManager(first:25)"
        }],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "AppFmoHomeViewerWhoAmIQuery",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatarUrl",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        }, {
          "alias": null,
          "args": v1 /*: any*/,
          "concreteType": "FleetCompanyConnection",
          "kind": "LinkedField",
          "name": "fleetCompaniesAsManager",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "FleetCompanyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "FleetCompany",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [{
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }, v3 /*: any*/, {
                "alias": null,
                "args": null,
                "concreteType": "FleetContract",
                "kind": "LinkedField",
                "name": "contract",
                "plural": false,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shortCode",
                  "storageKey": null
                }, v4 /*: any*/],
                "storageKey": null
              }, v4 /*: any*/, v2 /*: any*/],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": "fleetCompaniesAsManager(first:25)"
        }, v0 /*: any*/, v4 /*: any*/],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "7aca7fbe32cabf1196195bffa6a37877",
      "id": null,
      "metadata": {},
      "name": "AppFmoHomeViewerWhoAmIQuery",
      "operationKind": "query",
      "text": "query AppFmoHomeViewerWhoAmIQuery {\n  viewer {\n    ...Landing_FmoHomeViewer\n    canAccessPortal(portal: FLEET_PORTAL)\n    fleetCompaniesAsManager(first: 25) {\n      edges {\n        node {\n          dbId\n          slug\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment Landing_FmoHomeViewer on User {\n  avatarUrl\n  firstName\n  fleetCompaniesAsManager(first: 25) {\n    edges {\n      ...ViewerFleetCompaniesAsManagerList_ViewerFleetCompanies\n    }\n  }\n}\n\nfragment ViewerFleetCompaniesAsManagerList_ViewerFleetCompanies on FleetCompanyEdge {\n  node {\n    name\n    slug\n    contract {\n      shortCode\n      id\n    }\n    id\n  }\n}\n"
    }
  };
}();
node.hash = "03b6c59935b09eefafc75fee5620dd88";
export default node;